// src/pages/Services.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styled from 'styled-components';

const API_URL = 'https://hhq3fo1k2a.execute-api.us-east-1.amazonaws.com/prod/';

const ServicesWrapper = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const Title = styled.h1`
  color: #0C2340;
  text-align: center;
`;

const ServiceList = styled.ul`
  list-style-type: none;
  padding: 0;
`;

const ServiceItem = styled.li`
  background-color: #f8f8f8;
  border: 1px solid #ddd;
  border-radius: 5px;
  margin-bottom: 10px;
  padding: 15px;
`;

const ServiceName = styled.h3`
  color: #0C2340;
  margin: 0 0 10px 0;
`;

const ServiceDescription = styled.p`
  margin: 0;
`;

const Services = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await axios.get(`${API_URL}services`, {
          withCredentials: true, // Include cookies in the request
        });
        setServices(response.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch services. Please try again later.');
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <ServicesWrapper>
      <Title>Our Services</Title>
      <ServiceList>
        {services.map((service) => (
          <ServiceItem key={service.id}>
            <ServiceName>{service.name}</ServiceName>
            <ServiceDescription>{service.description}</ServiceDescription>
          </ServiceItem>
        ))}
      </ServiceList>
    </ServicesWrapper>
  );
};

export default Services;